import RequestCache from "./RequestCache";

export default class Clinics extends RequestCache {
    get cacheInterval() {
        return 7;
    }

    get link() {
        return this.links.clinics;
    }
}
